import React, { useEffect, useState } from "react";
import {
  ActivityIndicator,
  Dimensions,
  Image,
  Linking,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";
import HeaderTabs from "../../components/HeaderTabs";

import HeaderDefault from "../../components/HeaderDefault";

import { styles } from "./styles";

import AsyncStorage from "@react-native-async-storage/async-storage";
import toast from "../../utils/toast";
import CreditCardForm from "../../components/CreditCardForm";
import GradientButton from "../../components/GradientButton";
import { FormattedMessage } from "react-intl";
import { id } from "date-fns/locale";

const DepositNewCreditCard = () => {
  const navigation = useNavigation();

  function onSubmit(data) {
    const { creditCard, creditCardHolderInfo } = data;
    navigation.navigate({
      name: "DepositCreditCardSummary",
      params: { creditCard, creditCardHolderInfo },
    });
  }

  return (
    <View style={{ flex: 1 }}>
      <HeaderTabs
        title={<FormattedMessage id="depositnewcreditcard.depositarBrl" />}
      />

      <View style={styles.container}>
        <CreditCardForm
          onSubmit={onSubmit}
          submitText={<FormattedMessage id="depositnewcreditcard.continuar" />}
        />
      </View>
    </View>
  );
};

export default DepositNewCreditCard;
